export const capitalize = (word: string) => {
  return word
    .trim()
    .toLowerCase()
    .replace(/^\w/, (char) => char.toUpperCase());
};
